import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Navbar.css';

function Navbar({ currentSection, setCurrentSection }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (section) => {
    if (currentSection === section) {
      setCurrentSection('home');
    } else {
      setCurrentSection(section);
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar__mobile-logo">
        <img src="/vuelo_despierto_logo_blanco.png" alt="Vuelo Despierto" />
      </div>
      <div className={`navbar__hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={`navbar__links ${isMenuOpen ? 'active' : ''}`}>
        <div className="navbar__menu-items">
          <a
            onClick={() => handleNavClick('tour')}
            className={currentSection === 'tour' ? 'active' : ''}
          >
            Tour
          </a>
          <a
            onClick={() => handleNavClick('tienda')}
            className={currentSection === 'tienda' ? 'active' : ''}
          >
            Tienda
          </a>
          <a
            onClick={() => handleNavClick('fotos')}
            className={currentSection === 'fotos' ? 'active' : ''}
          >
            Fotos
          </a>
        </div>
        <div className="navbar__social">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://spotify.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-spotify"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 